// Generated by purs version 0.11.7
"use strict";
var $foreign = require("./foreign");
var Control_Monad_Eff = require("../Control.Monad.Eff");
module.exports = {
    mkEffFn1: $foreign.mkEffFn1,
    mkEffFn2: $foreign.mkEffFn2,
    mkEffFn3: $foreign.mkEffFn3,
    mkEffFn4: $foreign.mkEffFn4,
    mkEffFn5: $foreign.mkEffFn5,
    mkEffFn6: $foreign.mkEffFn6,
    mkEffFn7: $foreign.mkEffFn7,
    mkEffFn8: $foreign.mkEffFn8,
    mkEffFn9: $foreign.mkEffFn9,
    mkEffFn10: $foreign.mkEffFn10,
    runEffFn1: $foreign.runEffFn1,
    runEffFn2: $foreign.runEffFn2,
    runEffFn3: $foreign.runEffFn3,
    runEffFn4: $foreign.runEffFn4,
    runEffFn5: $foreign.runEffFn5,
    runEffFn6: $foreign.runEffFn6,
    runEffFn7: $foreign.runEffFn7,
    runEffFn8: $foreign.runEffFn8,
    runEffFn9: $foreign.runEffFn9,
    runEffFn10: $foreign.runEffFn10
};



//////////////////
// WEBPACK FOOTER
// ./output/Control.Monad.Eff.Uncurried/index.js
// module id = 587
// module chunks = 0